import React, { useEffect } from 'react';

export const NotFoundComponent: React.FC = () => {
  useEffect(() => {
    window.location.href = '/404';
  }, []);
  return null;
};
